export type StatsFilters = {
  map: string;
  dateRange: string;
  result: string;
};

export function buildStatsQueryParams(
  filters: StatsFilters,
  search?: string
): URLSearchParams {
  const params = new URLSearchParams();
  if (filters.map !== 'all') params.set('map', filters.map);
  if (filters.dateRange !== 'all') params.set('days', filters.dateRange);
  if (filters.result !== 'all') params.set('result', filters.result);
  if (search?.trim()) params.set('q', search.trim());
  return params;
}
